import {View} from 'MWC';
import tpl from '../../templates/desktop/main';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            cards: false,
            deposits: false,
            credit: false,
            business: false,
            services: false,
            businessCalculations: false,
            businessTrade: false,
            businessFreeMoney: false,
            businessFinancing: false,
            businessGov: false
        };

        this.toggleHover = this.toggleHover.bind(this);
        return this;
    }
    template = tpl;

    toggleHover(hover, name) {
        this.setState({[name]: hover});
    }

    static displayName = 'Header.Views.Desktop';
}
